// @flow
import {
  getUserDataFromFirebase,
  userRecordsSchema
} from "./connection/firebase-users.js";
import { setCrewValue } from "../redux-actions/battle-actions.js";
import makeId from "../helpers/make-id.js";
import { getLoadout } from "../Fixture_combatants.js";

function getDefaultCrewData() {
  /* Create dynamic memberIds */
  const ids = [1, 2, 3].map(num => {
    return makeId(`member-${num}`, 15);
  });
  return {
    [ids[0]]: {
      ...getLoadout("dpsA"),

      name: "Harold", //Default name. You should never actually see this though, as the onboarding overwrites it
      arenaPosition: 1, //main
      skinId: "skin_m3",
      memberId: ids[0]
    },
    [ids[1]]: {
      ...getLoadout("dpsB"),
      name: "Jessie",
      arenaPosition: 2,
      skinId: "skin_f2",
      memberId: ids[1]
    },
    [ids[2]]: {
      ...getLoadout("supportA"),
      name: "Sako",
      arenaPosition: 3,
      skinId: "skin_m2",
      memberId: ids[2]
    }
  };
}

/* App is starting! Load the user's crew to redux state (or pull from Firebase if they've been here before) */
export function b5LoadCrew(callback: Function) {
  //Check to see if we're logged in:
  let unsubscribe = window.firebase.auth().onAuthStateChanged(async user => {
    // console.log("firing b5LoadCrew after Firebase authStateChanged");

    //YES! We're logged in:
    if (user) {

      //Look up my data:
      const myData = await getUserDataFromFirebase(`client_${user.uid}`);
      if (!myData) {
        console.warn("this client_ does not exist in Firebase");
      }

      if (myData && myData["crewMembers"]) {
        //Look for crewMembers node in Firebase
        //crew exists. Use that one

        setCrewValue({
          logggedInUserId: user.uid,
          name: myData["crewName"] || "Crew", //This should never happen, but somehow this account's Crew Name was deleted from Firebase
          record: myData["battleRecord"] || { ...userRecordsSchema }, //defaults to empty record
          members: myData["crewMembers"] //Load my saved crew
        });

        unsubscribe(); //Remove this firebase listener (Don't let it fire twice)
        callback("returningUser"); //Let ths caller know that loaded data has been applied to state.


      } else {
        //User Data in Firebase has been deleted or missing valuable crewMembers
        //Not sure how this would ever happen, but who knows?
        //If this user data is no longer here - LOG OUT and act like it's our first time here
        //TODO: NOTE this block is a little redudant with "not logged in" state below, but meh.

        //I'm logged in, but somehow didn't have a crew saved. Give me all defaults.
        //Need to just use a default crew
        setCrewValue({
          logggedInUserId: null,
          name: myData ? myData["crewName"] || "Crew" : "Crew", //Try to use my crew name if I have one saved
          members: getDefaultCrewData(),
          record: { ...userRecordsSchema }
        });

        unsubscribe(); //Remove this firebase listener (Don't let it fire twice)

        //Sign out of stale account for a fresh start
        window.firebase.auth().signOut().then(function() {
          callback("newUser"); //Let ths caller know that loaded data has been applied to state.
        });
      }

    } else {
      //Not logged in
      //Need to just use a default crew.
      setCrewValue({
        logggedInUserId: null,
        name: "Crew", //This gets replaced in the onboarding process
        members: getDefaultCrewData(),
        record: { ...userRecordsSchema }
      });

      // console.log("removing firebase auth listener [user not logged in]");
      unsubscribe(); //Remove this firebase listener

      //Let ths caller know that data has been applied to state. (all defaults, really)
      callback("newUser"); //Will be ported to the Onboarding flow
    }
  });
}



// WEBPACK FOOTER //
// ./src/battle/b5LoadCrew.js